<div class="container">
  <div class="row back-navigation-btn">
    <div class="col text-left back-navigation-btn">
      <div
        appNavigateBack
        class="text-primary cursor-pointer d-inline-flex align-items-center py-2"
        (click)="navigateToPassengerChangeEditPage()"
      >
        <i class="mdi mdi-24px mdi-chevron-left"></i>
        <strong>{{ 'GENERAL.BACK_BTN' | translate }}</strong>
      </div>
    </div>
  </div>
  <stepper-bar [inputSteps]="stepperBarSteps" [currentStep]="stepperBarStepsEnum.Second"></stepper-bar>

  <div class="row">
    <div class="col">
      <h5>{{ 'PASSENGER_CHANGE.HEADERS.OVERVIEW' | translate }}</h5>
    </div>
  </div>

  <div class="row mb-3" *ngFor="let updated of updatedPassengers; let i = index">
    <div class="col" *ngIf="originalPassengers[i]">
      <div class="card">
        <div class="card-body p-3">
          <div class="d-flex">
            <div>
              <span class="mr-1">{{ 'PASSENGER_CHANGE.OLD_NAME' | translate }}:</span>
              <strong>
                <span class="crossed-out mr-2">
                  {{ getTitle(originalPassengers[i].genderType) }}
                  {{ originalPassengers[i].firstName | titlecase }} {{ originalPassengers[i].lastName | titlecase }}
                </span>
              </strong>
              <span class="old-date-passenger crossed-out ml-1">{{
                originalPassengers[i].dateOfBirth | date : dateFormatEnum.ddMMyyyy
              }}</span>
            </div>
            <div class="ml-5">
              <span class="mr-1">{{ 'PASSENGER_CHANGE.NEW_NAME' | translate }}:</span>

              <strong> {{ getTitle(updated.genderType) }} {{ updated.firstName | titlecase }} {{ updated.lastName | titlecase }} </strong>
              <span class="ml-1">{{ updated.dateOfBirth | date : dateFormatEnum.ddMMyyyy }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="priceSummary">
    <div class="col">
      <div class="price-header mt-4 mb-2">
        <h5>{{ 'PASSENGER_CHANGE.TOTAL_PRICE' | translate }}</h5>
      </div>
      <div class="card price-card">
        <div class="card-body p-0">
          <table class="table table-borderless mb-0">
            <tbody>
              <tr>
                <td class="p-3">{{ 'PASSENGER_CHANGE.CHANGE_FEE' | translate }} Airtrade ({{ getPassengerTypeLabel() }})</td>
                <td class="text-right p-3">€ {{ priceSummary.displayAirtradeFees }}</td>
              </tr>
              <tr>
                <td class="pt-0 pl-3 pb-3">{{ 'PASSENGER_CHANGE.FEES_AIRLINES' | translate }} ({{ getPassengerTypeLabel() }})</td>
                <td class="text-right pt-0 pl-3 pb-3 pr-3">€ {{ priceSummary.displayProviderFees }}</td>
              </tr>
              <tr class="border-top">
                <td></td>
                <td class="p-3 text-right">
                  {{ 'PASSENGER_CHANGE.TOTAL' | translate }}: <strong>€ {{ priceSummary.displayPrice }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="row py-3">
    <div class="col text-left back-navigation-btn">
      <div
        appNavigateBack
        class="text-primary cursor-pointer d-inline-flex align-items-center py-2"
        (click)="navigateToPassengerChangeEditPage()"
      >
        <i class="mdi mdi-24px mdi-chevron-left"></i>
        <strong>{{ 'GENERAL.BACK_BTN' | translate }}</strong>
      </div>
    </div>
    <div class="col text-right button-overview">
      <app-navigate-next-btn
        [handleOnClick]="true"
        [buttonClass]="'btn-overview'"
        [showIcon]="false"
        [isConfirm]="true"
        (onClick)="openFullscreenLoader()"
        class="float-right"
      ></app-navigate-next-btn>
    </div>
  </div>
</div>
